
import React, { useEffect, useState } from 'react';

interface InstagramPost {
  id: string;
  media_url: string;
  permalink: string;
  caption?: string;
  media_type: string;
  timestamp: string;
  like_count?: number;
  comments_count?: number;
}

const GallerySection: React.FC = () => {
  const [posts, setPosts] = useState<InstagramPost[]>([]);
  const [loading, setLoading] = useState(true);

  // Real Instagram posts from @eduardocabezaurologo
  const samplePosts: InstagramPost[] = [
    {
      id: '1',
      media_url: 'https://scontent.cdninstagram.com/v/t51.82787-15/590823640_17864720481533668_8948537919760540273_n.jpg?stp=dst-jpg_e35_tt6&_nc_cat=100&ig_cache_key=Mzc4MDQyNzQ4NjUxMDAxNDM1Mg%3D%3D.3-ccb7-5&ccb=7-5&_nc_sid=58cdad&efg=eyJ2ZW5jb2RlX3RhZyI6InhwaWRzLjEwODB4MTM1MC5zZHIuQzMifQ%3D%3D&_nc_ohc=bzh9B-_6oaYQ7kNvwHjKdFu&_nc_oc=AdngXIZx8J1het2UZql8CiZdY_QZ9p55fgokhTwnH14h1miNvu_Qd4LbcEcPx9IDOZs&_nc_ad=z-m&_nc_cid=0&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=fQg-lvS_jpzND2anxRODIg&oh=00_AfkoMWsuQvh8Loin8MhbTfsjWj9VSx7iBddSxHkfEKTZIg&oe=693C24E6',
      permalink: 'https://www.instagram.com/eduardocabezaurologo/',
      caption: 'Hay esperanza después de los 50! Con cirugía mínimamente invasiva (Láser o Urológica)',
      media_type: 'image',
      timestamp: '2025-12-05T10:00:00Z',
      like_count: 245,
      comments_count: 18
    },
    {
      id: '2',
      media_url: 'https://scontent.cdninstagram.com/v/t51.82787-15/589087121_17864347716533668_7517536252024264482_n.jpg?stp=dst-jpg_e35_tt6&_nc_cat=108&ig_cache_key=Mzc3ODEwMjI2MTk1NzA2MzY5OQ%3D%3D.3-ccb7-5&ccb=7-5&_nc_sid=58cdad&efg=eyJ2ZW5jb2RlX3RhZyI6InhwaWRzLjEwODB4MTM1MC5zZHIuQzMifQ%3D%3D&_nc_ohc=B4YbHed_e4gQ7kNvwEmtxEu&_nc_oc=AdmKocJ2gFilIsbo2h01lr67DsojiLz-gv-9O04O-0VflCQu0_hWWeBEDnexzMx-fHA&_nc_ad=z-m&_nc_cid=0&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=hhLiqPpKNmHVupvY6jV9gA&oh=00_Afke-8Ya12LLnrM2B0yzKn-SM7sGhxRP6nMOLWGUp4Uefw&oe=693C4896',
      permalink: 'https://www.instagram.com/eduardocabezaurologo/',
      caption: 'La disfunción eréctil no se trata solo de deseo, sino de circulación, hormonas y bienestar general.',
      media_type: 'image',
      timestamp: '2025-12-02T15:30:00Z',
      like_count: 189,
      comments_count: 12
    },
    {
      id: '3',
      media_url: 'https://scontent.cdninstagram.com/v/t51.82787-15/587708808_17863769499533668_7878127708962518414_n.jpg?stp=dst-jpg_e35_tt6&_nc_cat=109&ig_cache_key=Mzc3NDQ3ODU2OTU0NDk4MTQ5MA%3D%3D.3-ccb7-5&ccb=7-5&_nc_sid=58cdad&efg=eyJ2ZW5jb2RlX3RhZyI6InhwaWRzLjEwODB4MTM1MC5zZHIuQzMifQ%3D%3D&_nc_ohc=zdzbiVsE8OgQ7kNvwHFX8-X&_nc_oc=AdkzG_PKFQpIRweqUjq8z7_qwprN0zqkV-iodyGo0_qzCI1iP2O5YoO3jTO7P26_r3Q&_nc_ad=z-m&_nc_cid=0&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=jQljKZfhk5PvO3w7Q_jrvg&oh=00_AflxROe4EuCC-OHeYRSt8gAlZYEsz9liosFERJCeW1Ho4Q&oe=693C4A6A',
      permalink: 'https://www.instagram.com/eduardocabezaurologo/',
      caption: 'Tecnología láser en tratamientos urológicos #Láser #Innovación #Medicina',
      media_type: 'image',
      timestamp: '2025-11-26T09:15:00Z',
      like_count: 156,
      comments_count: 8
    },
    {
      id: '4',
      media_url: 'https://scontent.cdninstagram.com/v/t51.82787-15/584378215_17862886431533668_3203851507974709552_n.jpg?stp=dst-jpg_e35_tt6&_nc_cat=101&ig_cache_key=Mzc2ODg5NDAxNDQ4NjIzMzQyNw%3D%3D.3-ccb7-5&ccb=7-5&_nc_sid=58cdad&efg=eyJ2ZW5jb2RlX3RhZyI6InhwaWRzLjEwODB4MTM1MC5zZHIuQzMifQ%3D%3D&_nc_ohc=QcKZ7Lj1ZIYQ7kNvwG5pNJA&_nc_oc=AdksRmV58PiG8dZUdN1fKbza5WdKAqxrxmyUNGfaKrzX4iiCGaKn3sZ1KDCAs9pdzkU&_nc_ad=z-m&_nc_cid=0&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=jQljKZfhk5PvO3w7Q_jrvg&oh=00_AfniuLrB-lQw-mITUPsV-HSjG56a6CS44K1CIT2FQYjgMA&oe=693C2399',
      permalink: 'https://www.instagram.com/eduardocabezaurologo/',
      caption: 'Detectarlo a tiempo hace toda la diferencia.Si notas sangre en la orina, dolor al orinar o infecciones que no ceden, no lo ignores.',
      media_type: 'image',
      timestamp: '2025-11-18T14:20:00Z',
      like_count: 203,
      comments_count: 15
    },
    {
      id: '5',
      media_url: 'https://scontent.cdninstagram.com/v/t51.82787-15/583900698_17862742125533668_6595111450862231653_n.jpg?stp=dst-jpg_e35_tt6&_nc_cat=109&ig_cache_key=Mzc2Nzk1NTM5Mzk1MjM3NTE1Nw%3D%3D.3-ccb7-5&ccb=7-5&_nc_sid=58cdad&efg=eyJ2ZW5jb2RlX3RhZyI6InhwaWRzLjEwODB4MTM1MC5zZHIuQzMifQ%3D%3D&_nc_ohc=lGmgJbVsK20Q7kNvwF4HbIj&_nc_oc=AdmlEylsPIe_1FdiQWxLlp_OZv4g2JNfdtapTaDQKJ7MkRma2GoTtYvwwq8s8fNOBtY&_nc_ad=z-m&_nc_cid=0&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=jQljKZfhk5PvO3w7Q_jrvg&oh=00_AflBTh4Oi3ZgjKMLqrBOQRLMUp8O18jXHefahxzIC5PSGw&oe=693C2931',
      permalink: 'https://www.instagram.com/eduardocabezaurologo/',
      caption: 'Cada cita que pospones puede retrasar una solución definitiva.No dejes que el miedo o la costumbre te alejen del bienestar que mereces.',
      media_type: 'image',
      timestamp: '2025-11-17T11:45:00Z',
      like_count: 178,
      comments_count: 10
    },
    {
      id: '6',
      media_url: 'https://scontent.cdninstagram.com/v/t51.82787-15/581725914_17862550065533668_380837618003071163_n.jpg?stp=dst-jpg_e35_tt6&_nc_cat=111&ig_cache_key=Mzc2NjY2OTQxNzgzODE5ODE5Nw%3D%3D.3-ccb7-5&ccb=7-5&_nc_sid=58cdad&efg=eyJ2ZW5jb2RlX3RhZyI6InhwaWRzLjEwODB4MTA4MC5zZHIuQzMifQ%3D%3D&_nc_ohc=u-9o8owrgN4Q7kNvwFUUMUA&_nc_oc=AdkeylJBMPudJDegMhbaLNfWy2nCQfMaz6rchUaQhBTITfU8YVjBLqIooY07ff_YL-8&_nc_ad=z-m&_nc_cid=0&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=jQljKZfhk5PvO3w7Q_jrvg&oh=00_Afn0vFIr8zsGo4eRvY-IVu-ujCXPi-WzhB9bborNaIyK9w&oe=693C4411',
      permalink: 'https://www.instagram.com/eduardocabezaurologo/',
      caption: 'Se acerca el mejor congreso de Urología en México…. Nos vemos ahí para compartir conocimiento y experiencias. #SMU25',
      media_type: 'image',
      timestamp: '2025-11-15T16:00:00Z',
      like_count: 267,
      comments_count: 22
    }
  ];

  useEffect(() => {
    setTimeout(() => {
      setPosts(samplePosts);
      setLoading(false);
    }, 1000);
  }, []);

  const formatLikes = (count: number) => {
    if (count >= 1000) {
      return `${(count / 1000).toFixed(1)}K`;
    }
    return count.toString();
  };

  const formatDate = (timestamp: string) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffTime = Math.abs(now.getTime() - date.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays === 1) return 'Ayer';
    if (diffDays < 7) return `Hace ${diffDays} días`;
    if (diffDays < 30) return `Hace ${Math.floor(diffDays / 7)} semanas`;
    return `Hace ${Math.floor(diffDays / 30)} meses`;
  };

  return (
    <section id="galeria" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Feed de Instagram</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Sigue al Dr. Eduardo Cabeza Bucio en Instagram para contenido educativo, casos clínicos y las últimas novedades en urología.
          </p>
        </div>

        <div className="text-center mb-8">
          <div className="inline-flex items-center bg-gradient-to-r from-purple-50 to-pink-50 rounded-full px-6 py-3 mb-4">
            <i className="ri-instagram-line text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-600 text-2xl mr-3"></i>
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-800 to-pink-800 font-semibold">
              @eduardocabezaurologo
            </span>
          </div>
          <p className="text-gray-600">Miles de seguidores • Contenido Urológico especializado • Tips de salud</p>
        </div>

        {loading ? (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {[...Array(6)].map((_, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden animate-pulse">
                <div className="h-64 bg-gray-200"></div>
                <div className="p-4">
                  <div className="h-4 bg-gray-200 rounded mb-2"></div>
                  <div className="h-3 bg-gray-200 rounded w-3/4"></div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {posts.map((post) => (
              <div
                key={post.id}
                className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer group"
                onClick={() => window.open(post.permalink, '_blank')}
              >
                <div className="relative h-64 overflow-hidden">
                  <img
                    alt="Instagram post"
                    className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-300"
                    src={post.media_url}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="absolute bottom-4 left-4 right-4 text-white">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-3">
                          <div className="flex items-center">
                            <i className="ri-heart-fill text-sm mr-1"></i>
                            <span className="text-sm font-semibold">{formatLikes(post.like_count || 0)}</span>
                          </div>
                          <div className="flex items-center">
                            <i className="ri-chat-3-fill text-sm mr-1"></i>
                            <span className="text-sm font-semibold">{post.comments_count || 0}</span>
                          </div>
                        </div>
                        <i className="ri-instagram-line text-lg"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="p-4">
                  <p className="text-sm text-gray-700 line-clamp-2 leading-relaxed mb-2">
                    {post.caption}
                  </p>
                  <div className="flex items-center text-xs text-gray-500">
                    <i className="ri-time-line mr-1"></i>
                    <span>{formatDate(post.timestamp)}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="text-center mt-12">
          <a
            href="https://www.instagram.com/eduardocabezaurologo/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center bg-gradient-to-r from-purple-600 to-pink-600 text-white px-8 py-4 rounded-xl font-semibold hover:from-purple-700 hover:to-pink-700 transition-all duration-300 whitespace-nowrap cursor-pointer transform hover:scale-105 shadow-lg"
          >
            <i className="ri-instagram-line text-xl mr-2"></i>
            Síguenos en Instagram
          </a>
        </div>

        <div className="mt-16 bg-gradient-to-r from-purple-100 to-pink-100 rounded-2xl p-8">
          <div className="text-center">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Contenido Educativo Diario
            </h3>
            <p className="text-gray-700 mb-6 max-w-3xl mx-auto">
              En nuestro Instagram encontrarás información actualizada sobre urología, 
              prevención de enfermedades y consejos para mantener tu salud urológica en óptimas condiciones.
            </p>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-3 shadow-md">
                  <i className="ri-graduation-cap-line text-purple-600 text-xl"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-1">Educación</h4>
                <p className="text-sm text-gray-600">Tips médicos y explicaciones sencillas</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-3 shadow-md">
                  <i className="ri-hospital-line text-pink-600 text-xl"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-1">Casos Clínicos</h4>
                <p className="text-sm text-gray-600">Ejemplos reales de tratamientos exitosos</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-3 shadow-md">
                  <i className="ri-message-3-line text-purple-600 text-xl"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-1">Interacción</h4>
                <p className="text-sm text-gray-600">Responde a tus dudas médicas</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
